export const BRAND = "Anchorwell";
export const BRAND_FULL = "Anchorwell Life & Health";
export const AGENT_NAME = "Jean Max Andre";
export const PHONE_DISPLAY = "(754) 663-3225";
export const PHONE_TEL = "+17546633225";
export const EMAIL = "jeanmaxajr@gmail.com";
export const BOOK_URL = "https://calendly.com/jeanmaxajr";

export const COVERAGE_OPTIONS = [
  "ACA / Obamacare",
  "Private Health Plan",
  "Dental, Vision & Hearing",
  "Final Expense",
  "IUL",
  "Whole Life",
  "College Savings",
  "Retirement Planning",
];

export const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming",
];

export const openQuote = (tab) => {
  window.dispatchEvent(new CustomEvent("quote-tab", { detail: tab }));
  scrollToId("quote");
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
